import React from 'react'
import AppContext from 'AppContext'
import { featureEnabled, env } from 'components/Helpers'
import { NotEnabledPage } from 'scenes/NotEnabled'

const Documents = (props) => {
  const token = window.localStorage.getItem('auth-token')

  const { operator: { id, name, locales } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index documents' />
    )
  }

  if (!featureEnabled('documents', id)) {
    return (<NotEnabledPage />)
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index documents'>
      {/* eslint-disable-next-line */}
      <h1></h1>

      <cl-documents
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/documents`}
        token={token}
        operatorid={id}
        operatorName={name.toUpperCase()}
        locales={locales}
      ></cl-documents>
    </div>
  )
}

export default Documents
